import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import OwnershipTransferPrivateSellerBlockData from '../../../Models/Content/OwnershipTransferPrivateSellerBlockData';
import OwnershipTransferSeller from './OwnershipTransferSeller';

export default class OwnershipTransferSellerBlock extends EpiComponent<OwnershipTransferPrivateSellerBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <OwnershipTransferSeller iContent={this.props.data} />;
  }
}
